import { render, staticRenderFns } from "./page-plan-insurance-packages.vue?vue&type=template&id=2b3ba0ea"
import script from "./page-plan-insurance-packages.js?vue&type=script&lang=js&external"
export * from "./page-plan-insurance-packages.js?vue&type=script&lang=js&external"
import style0 from "./page-plan-insurance-packages.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports